/** Namespace `partnerLab` — HQ-2026-008: « Phòng thử Tingee » cho MỘT bộ thông số. Bản gốc tiếng Việt. */
export const partnerLab = {
  title: "Phòng thử Tingee",
  subtitle: "Bộ « {name} » · {env} · {product}",
  back: "← Về Tích hợp",
  intro:
    "Gọi THẬT Open API Tingee bằng bộ thông số này, trước khi bật cho app. Nút đỏ tạo / xoá / bật thứ gì đó thật ở Tingee và ngân hàng — bấm hai lần để gửi.",
  loading: "Đang tải…",
  notFound: "Không tìm thấy bộ thông số này (hoặc không phải sản phẩm Tingee).",
  webhookTitle: "URL webhook",
  webhookHelp: "Dán vào cổng Tingee › Webhook (hoặc gửi kèm `webhookUrl` khi tạo VA). Tingee ký bằng secret của bộ này.",
  webhookLocalWarning: "Máy chủ hub chưa khai HQ_PUBLIC_API_URL — URL ghép từ địa chỉ dashboard; Tingee chỉ gọi tới được nếu địa chỉ này công khai.",
  copy: "Chép",
  copied: "Đã chép",
  send: "Gửi",
  confirmSend: "Bấm lần nữa để GỬI THẬT",
  sending: "Đang gọi…",
  resultTitle: "Kết quả",
  resultEmpty: "Chưa gọi hàm nào.",
  actionLinkHelp: "Bước tiếp theo ở trang ngân hàng ({key}): đăng nhập, nhập OTP ngân hàng gửi, đồng ý liên kết. Xong thì chờ tin va_status trong bảng webhook bên dưới.",
  actionLinkOpen: "Mở link xác thực",
  rawWriteWarning: "Hàm GHI — tạo / xoá / bật / tắt / trích tiền / in thật ở Tingee và ngân hàng. Bấm hai lần; có ghi audit.",
  rawReadOnly: "Hàm chỉ đọc — không đổi gì.",
  rawDocs: "Tra tham số trong tài liệu SDK ↗",
  bankLinkWidgetTitle: "Liên kết tài khoản ngân hàng",
  bankLinkWidgetHelp: "Chọn ngân hàng, đăng nhập và xác nhận bằng mã OTP do ngân hàng gửi.",
  bankLinkWidgetBadUrl: "URL không phải widget liên kết của Tingee (chỉ nhận https://bank-link.tingee.vn hoặc uat-bank-link.tingee.vn).",
  bankLinkWidgetResult: "Widget trả về: {status}",
  bankLinkWidgetOpen: "Mở widget liên kết",
  resultOk: "Thành công",
  resultError: "Lỗi",
  eventsTitle: "Sự kiện webhook (tự làm mới 3 giây)",
  eventsEmpty: "Chưa nhận sự kiện nào.",
  clearEvents: "Xoá nhật ký",
  "col.time": "Lúc nhận",
  "col.kind": "Loại",
  "col.verified": "Chữ ký",
  "col.amount": "Số tiền",
  "col.account": "Tài khoản",
  "col.content": "Nội dung",
  verifiedYes: "Hợp lệ",
  verifiedNo: "Sai ({reason})",
  bankPick: "— chọn ngân hàng —",
  loadBanksFirst: "Bấm « Danh sách ngân hàng » trước để chọn.",
  paramsJson: "Tham số (JSON)",
  invalidJson: "JSON không hợp lệ.",
  windowTooLong: "Khoảng thời gian tối đa 10 ngày.",
  apiPicker: "Chọn API",
  rawShort: "Gọi hàm SDK bất kỳ",
  badgeRead: "Chỉ đọc",
  badgeWrite: "Có ghi — bấm hai lần",
  needBanksBefore: "Chưa có danh sách ngân hàng cho ô « Ngân hàng » — chạy trước:",
  "section.read": "Đọc (không đổi gì)",
  "section.va": "Tài khoản ảo (VA)",
  "section.notify": "Đăng ký nhận biến động bổ sung",
  "section.qr": "QR động",
  "section.link": "Phiên liên kết ngân hàng",
  "section.raw": "Gọi hàm SDK (đủ 72 hàm của @tingee/sdk-node)",
  "action.banks": "Danh sách ngân hàng",
  "action.transactions": "Giao dịch (≤ 10 ngày)",
  "action.vaPaging": "Danh sách VA",
  "action.vaCreate": "Tạo VA",
  "action.vaConfirm": "Xác nhận VA (OTP)",
  "action.vaDelete": "Xoá VA",
  "action.vaDeleteConfirm": "Xác nhận xoá VA (OTP)",
  "action.notifyAccount": "Đăng ký bổ sung (sau khi có VA)",
  badTime: "Mốc thời gian không đọc được — dùng yyyyMMddHHmmss (giờ VN) hoặc ISO.",
  "hint.notifyAccount": "Bước bổ sung SAU khi đã có VA — chỉ vài ngân hàng (vd ACB) dùng. Muốn nhận biến động trên STK thật: « Tạo VA » + tích « Báo biến động TK gốc », hoặc Kịch bản › Luồng chuẩn VA chọn « Số tài khoản gốc ».",
  "hint.error1059": "Ngân hàng này không dùng bước đăng ký bổ sung. Dùng « Tạo VA » + tích « Báo biến động TK gốc » (hoặc Kịch bản › Luồng chuẩn VA / Luồng Bank Link).",
  "action.notifyAccountConfirm": "Xác nhận nhận thông báo (OTP)",
  "action.qrCreate": "Tạo QR động",
  "action.qrStatus": "Trạng thái QR",
  "action.qrDelete": "Xoá QR",
  "action.bankLinkSession": "Tạo phiên liên kết",
  "action.call": "Gọi",
  "field.merchantId": "Merchant ID",
  "field.shopId": "Shop ID",
  "field.merchantAccountNumberId": "Merchant account number ID",
  "field.skipCount": "Bỏ qua",
  "field.maxResultCount": "Số dòng",
  "field.startTime": "Từ (yyyyMMddHHmmss hoặc ISO) — trống = 24 giờ qua",
  "field.endTime": "Đến (yyyyMMddHHmmss hoặc ISO) — trống = bây giờ",
  "field.vaAccountNumbers": "Số VA (phân tách dấu phẩy)",
  "field.bank": "Ngân hàng",
  "field.accountType": "Loại tài khoản",
  "field.accountNumber": "Số tài khoản",
  "field.accountName": "Tên chủ tài khoản",
  "field.identity": "CCCD / MST",
  "field.mobile": "Số điện thoại",
  "field.appType": "appType",
  "field.minAmount": "Số tiền tối thiểu",
  "field.maxAmount": "Số tiền tối đa",
  "field.isNotifyAccountNumber": "Báo biến động TK gốc (không qua VA)",
  "field.webhookUrl": "webhookUrl",
  "field.dataAccess": "dataAccess",
  "field.transactionType": "transactionType",
  "field.confirmId": "confirmId",
  "field.otpNumber": "Mã OTP",
  "field.vaAccountNumber": "Số VA",
  "field.qrCodeType": "Loại QR",
  "field.amount": "Số tiền",
  "field.purpose": "Nội dung",
  "field.expireInMinute": "Hết hạn sau (phút)",
  "field.qrAccount": "qrAccount",
  "field.billId": "billId",
  "field.type": "Kiểu phiên",
  "field.redirectUrl": "redirectUrl",
  "field.metadata": "metadata",
  "field.requestId": "requestId (TPBank: bắt buộc, mỗi lần một mã mới)",
  "field.allowedBanks": "allowedBanks (mã, cách nhau dấu phẩy — trống = mọi ngân hàng)",
  "field.vaPrefix": "Tiền tố VA (BIDV / VietinBank DN)",
  "field.vaSuffix": "Hậu tố VA (BIDV / VietinBank / OCB DN)",
  "field.merchantName": "Tên điểm bán (bắt đầu bằng tên DN đăng ký)",
  "field.merchantAddress": "Địa chỉ DN",
  "field.taxCode": "Mã số thuế",
  "field.acbUserId": "ACB User ID (ACB HKD / DN)",
  "field.walletId": "Wallet ID (BAOKIM)",
  "section.webhook": "Webhook (đăng ký ở Tingee)",
  "action.webhookSubscribe": "Đăng ký webhook",
  "webhook.loading": "Đang tải đích webhook…",
  "webhook.target": "URL nhận",
  "webhook.targetLab": "Phòng thử của bộ này",
  "webhook.targetApp": "App {app} (production, {env})",
  "webhook.urlMissing": "(hub chưa khai HQ_PUBLIC_API_URL)",
  "webhook.scope": "Phạm vi",
  "webhook.scope.accountNumber": "Theo VA / số tài khoản",
  "webhook.scope.shop": "Theo shop",
  "webhook.scope.merchant": "Theo merchant",
  "webhook.targetId": "ID shop / merchant (Tingee)",
  "webhook.active": "Bật (bỏ tích = tắt URL này cho phạm vi)",
  "webhook.receiver": "Bên nhận kiểm chữ ký bằng Client ID {hint}",
  "webhook.receiverNone": "App chưa gán bộ thông số nào cho môi trường này — bên nhận chưa có khoá để kiểm chữ ký.",
  "webhook.receiverOtherSet": "Bên nhận dùng bộ KHÁC bộ đang thử — webhook Tingee ký bằng bộ này sẽ bị bên nhận từ chối.",
  "webhook.authNote": "Ở cổng Tingee, chọn xác thực API Credentials với ĐÚNG cặp Client ID/Secret của bộ này — webhook ký bằng cặp khác sẽ bị 401.",
  "webhook.unmeasured": "webhook-notification chỉ có trong SDK, chưa có trong docs Tingee: nghĩa của phạm vi và việc có ghi đè URL cũ hay không CHƯA ĐO. Không có phạm vi « all » (sẽ đè webhook của nơi khác dùng cùng khoá).",
  "webhook.alphaVaHint": "Số có chữ (AGBHENO…) là VA của VPBank qua liên kết ngân hàng — Tingee liệt kê nó là VA active; đăng ký theo VA này như mọi VA khác.",
  "webhook.scopesLoading": "Đang đọc merchant / shop / VA của bộ từ Tingee…",
  "webhook.scopesFailed": "Không đọc được danh sách từ Tingee — nhập tay. {error}",
  "webhook.scopesNeedWrite": "Cần quyền sửa tích hợp để đọc danh sách merchant / shop / VA từ Tingee.",
  "webhook.scopesWarnings": "Một số lượt đọc lỗi: {list}",
  "webhook.scopesTruncated": "Danh sách bị cắt ở trần trang — lọc để tìm, hoặc nhập tay nếu không thấy.",
  "webhook.pickShop": "Shop",
  "webhook.pickMerchant": "Merchant",
  "webhook.search": "Lọc theo số / tên…",
  "webhook.choose": "— chọn —",
  "webhook.noOptions": "Tingee không trả mục nào cho khoá này.",
  "webhook.batch": "Đăng ký cho mọi VA của bộ này ({n})",
  "webhook.batchConfirm": "Bấm lần nữa để GỬI THẬT cho {n} VA",
  "webhook.batchRunning": "Đang gửi {done}/{n}…",
  "webhook.batchOk": "nhận",
  "webhook.batchFailed": "lỗi {code}",
  "webhook.batchStopped": "Dừng ở VA này — lỗi xác thực / máy chủ từ chối, không gửi tiếp.",
  "webhook.batchSummary": "{ok}/{n} VA được Tingee nhận.",
  "webhook.batchNote": "Gửi lần lượt từng VA (theo VA, không « all »), cùng đích ở trên (gồm cả VA có chữ của VPBank); dừng ở lỗi xác thực đầu tiên.",
  "field.method": "Hàm",
} as const;
